import { render } from "./TermsAdmin.vue?vue&type=template&id=dfaafb42"
import script from "./TermsAdmin.vue?vue&type=script&lang=js"
export * from "./TermsAdmin.vue?vue&type=script&lang=js"

import "./TermsAdmin.vue?vue&type=style&index=0&id=dfaafb42&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__